/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EAFSGAreaUpdateDTO
 */
export interface EAFSGAreaUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof EAFSGAreaUpdateDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EAFSGAreaUpdateDTO
     */
    description?: string | null;
}

export function EAFSGAreaUpdateDTOFromJSON(json: any): EAFSGAreaUpdateDTO {
    return EAFSGAreaUpdateDTOFromJSONTyped(json, false);
}

export function EAFSGAreaUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EAFSGAreaUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function EAFSGAreaUpdateDTOToJSON(value?: EAFSGAreaUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
    };
}

